import { defineStore } from 'pinia';
import { i18n } from '@/i18n';
import useConfig from './config';

type Locale = {
  currentLocale: string;
  availableLocales: string[];
};

export default defineStore('locale', {
  state: (): Locale => ({
    currentLocale: 'en',
    availableLocales: ['en', 'cs', 'fi']
  }),

  getters: {
    getCurrentLocale: (state) => state.currentLocale,
    getAvailableLocales: (state) => state.availableLocales
  },

  actions: {
    initializeLocale() {
      const normalize = (value?: string | null) => value ? value.split('-')[0].toLowerCase() : undefined;
      
      const savedLocale = normalize(localStorage.getItem('locale'));
      const tenantDefault = normalize(useConfig().configuration.defaultCulture);
      
      const preferred = (savedLocale && this.availableLocales.includes(savedLocale) && savedLocale) || (tenantDefault && this.availableLocales.includes(tenantDefault) && tenantDefault) || 'en';
      
      this.setLocale(preferred);
    },

    setLocale(locale: string) {
      if (this.availableLocales.includes(locale)) {
        this.currentLocale = locale;
        localStorage.setItem('locale', locale);
        this.updateI18nLocale();
      }
    },

    updateI18nLocale() {
      i18n.global.locale.value = this.currentLocale;
    }
  },
});